import { formatInTimeZone } from 'date-fns-tz';
import {
  startOfMonth, endOfMonth, subMonths, subDays,
} from 'date-fns';
import type { TimeWindow } from '../types';

const TZ = 'America/Sao_Paulo';

function fmt(d: Date): string {
  return formatInTimeZone(d, TZ, 'yyyy-MM-dd');
}

type Preset = TimeWindow['preset'];

const PRESETS: { label: string; value: Preset }[] = [
  { label: 'Hoje', value: 'today' },
  { label: 'Ontem', value: 'yesterday' },
  { label: '7 dias', value: '7d' },
  { label: '14 dias', value: '14d' },
  { label: '30 dias', value: '30d' },
  { label: 'Este mês', value: 'this-month' },
  { label: 'Mês passado', value: 'last-month' },
];

export function presetToDateRange(preset: Preset): { startDate: string; endDate: string } {
  const now = new Date();
  switch (preset) {
    case 'today':
      return { startDate: fmt(now), endDate: fmt(now) };
    case 'yesterday': {
      const y = subDays(now, 1);
      return { startDate: fmt(y), endDate: fmt(y) };
    }
    case '7d':
      return { startDate: fmt(subDays(now, 6)), endDate: fmt(now) };
    case '14d':
      return { startDate: fmt(subDays(now, 13)), endDate: fmt(now) };
    case '30d':
      return { startDate: fmt(subDays(now, 29)), endDate: fmt(now) };
    case 'this-month':
      return { startDate: fmt(startOfMonth(now)), endDate: fmt(now) };
    case 'last-month': {
      const lm = subMonths(now, 1);
      return { startDate: fmt(startOfMonth(lm)), endDate: fmt(endOfMonth(lm)) };
    }
    default:
      return { startDate: fmt(subDays(now, 29)), endDate: fmt(now) };
  }
}

interface Props {
  value: Preset;
  onChange: (preset: Preset) => void;
}

export function TimeWindowPicker({ value, onChange }: Props) {
  return (
    <div style={{
      display: 'flex',
      gap: '4px',
      background: 'var(--bg-tertiary)',
      padding: '3px',
      borderRadius: '8px',
      border: '1px solid var(--border-subtle)',
    }}>
      {PRESETS.map(p => (
        <button
          key={p.value}
          onClick={() => onChange(p.value)}
          style={{
            padding: '5px 10px',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '12px',
            fontFamily: 'var(--font-mono)',
            fontWeight: 500,
            background: value === p.value ? 'var(--bg-elevated)' : 'transparent',
            color: value === p.value ? 'var(--text-primary)' : 'var(--text-tertiary)',
            borderWidth: value === p.value ? '1px' : '0',
            borderStyle: 'solid',
            borderColor: value === p.value ? 'var(--border-default)' : 'transparent',
            transition: 'all 0.15s ease',
            whiteSpace: 'nowrap',
          }}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
